module.exports = __webpack_public_path__ + "static/tv2-ee6937ec35f8f1a054911d7ff07f714b.png";